//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    blok: {
      type: Object,
      required: true,
    },
  },
  computed: {
    linkComponent() {
      return this.isExternalLink ? 'a' : 'nuxt-link';
    },
    hasIcon() {
      return this.blok?.icon?.filename;
    },
    isExternalLink() {
      return (
        this.blok?.link?.linktype === 'url' ||
        this.blok?.link?.url.startsWith('https')
      );
    },
    to() {
      return !this.isExternalLink ? this.blok?.link?.cached_url : '';
    },
    href() {
      return this.isExternalLink ? this.blok?.link?.url : '';
    },
    target() {
      return this.isExternalLink ? '_blank' : '';
    },
    cssVars() {
      return {};
    },
  },
};
